const RESOURCE_NAME = '/xroutes';
import restApi from "@/api/rest-api-object";
// import axios from "@/api/http-auth";
import config from "@/config";
const baseURL = config.api.baseURL

export default axios => ({
    ...restApi(axios, RESOURCE_NAME, {baseURL}),

    getAll(unitId, params) {
        let url = `${RESOURCE_NAME}`;
        if(unitId) url = `units/${unitId}${RESOURCE_NAME}`
        return axios.get(url, {params, baseURL});
    },

});